import React, { useEffect } from "react";
import { FaTimes } from "react-icons/fa";
import { TextShimmer } from "../shimmer/shimmer";
import { FaSearch } from "react-icons/fa";
import { Button, Checkbox } from "antd";
import { ButtonSpinner } from "../spinners";

const MultySelect = ({ data, setData, search, submit }) => {
  const option = data?.options; // Assuming data is defined

  const filteredOptions = option.filter((item) => item.remaining === 0);

  // Now, filteredOptions contains only the options where remaining is equal to 0

  const closeModal = () => {
    setData({
      ...data,
      isMultySelect: false,
    });
  };

  const handleMultySelect = {
    check: (e, id) => {
      if (e?.target?.checked) {
        let allselectedOption = [...data?.selectedOption];
        allselectedOption?.push(id);

        setData({
          ...data,
          selectedOption: allselectedOption,
        });
      } else {
        let allselectedOption = [...data?.selectedOption];
        allselectedOption?.splice(allselectedOption?.indexOf(id), 1);

        setData({
          ...data,
          selectedOption: allselectedOption,
        });
      }
    },
  };

  useEffect(() => {
    (async () => {
      await search();
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="modal fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="modal-content bg-white w-[600px] max-h-[600px] rounded-md relative flex flex-col">
        {/* Close Button */}

        {data?.isShimmer ? (
          <div className="p-4 overflow-y-auto">
            <TextShimmer data={{ gap: 15, line: 20 }} />
          </div>
        ) : (
          <>
            {/* Title */}
            <div className="  flex justify-between">
              <h2 className="text-xl font-bold">{data?.title}</h2>
              <div className="">
                <button className="close-modal" onClick={closeModal}>
                  <FaTimes />
                </button>
              </div>
            </div>

            {/* Fixed Search Bar */}
            <div className="p-4 bg-white sticky top-0 z-10">
              <div className="border border-[#111111] flex items-center p-1 rounded-md w-full bg-white">
                <FaSearch className="ml-2" />
                <input
                  placeholder={data?.searchBarTitle}
                  className="h-[31px] bg-transparent text-sm w-full px-2"
                  onChange={search}
                />
              </div>
            </div>

            {/* Scrollable Options List */}
            <div className="overflow-y-auto flex-1 px-4">
              <div className="border divide-y rounded-md">
                {data?.options?.map((item, index) => (
                  <div
                    className="px-6 py-2 hover:bg-slate-100 cursor-pointer flex justify-between"
                    key={item?.id}
                  >
                    <label className="text-sm" htmlFor={item?.id}>
                      {item?.name}
                    </label>
                    <Checkbox
                      id={item?.id}
                      checked={data?.selectedOption?.includes(item?.id)}
                      onChange={(e) => handleMultySelect?.check(e, item?.id)}
                    />
                  </div>
                ))}
              </div>
            </div>

            {/* Fixed Submit Button */}
            <div className="p-4 justify-end flex  bg-white sticky bottom-0 z-10">
              <Button
                className="w-f btn btn-blue bg-blue-disable"
                onClick={submit}
                disabled={data?.isLoading}
              >
                {data?.isLoading ? <ButtonSpinner /> : data?.buttonTitle}
              </Button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default MultySelect;
